import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImagine: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="imagine, head, thinking"><path d="M6.75 22V15.8307C4.87984 14.5325 3.75 12.3756 3.75 9.93421C3.75 5.96648 6.98194 2.75 10.9688 2.75C14.9556 2.75 18.1875 5.96648 18.1875 9.93421L20.25 13.0132L18.1875 14.5526V17.25C18.1875 17.8023 17.7398 18.25 17.1875 18.25H13.75V22" stroke="currentColor" strokeWidth="1.5"/><path d="M11.35 6.5H10.65L9.775 8.775L7.5 9.65V10.35L9.775 11.225L10.65 13.5H11.35L12.225 11.225L14.5 10.35V9.65L12.225 8.775L11.35 6.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconImagine;
